
const initLinkSlider = () => {
  const linkSlider = document.querySelector('.link-slider');

  if (!linkSlider) return;

  const previousBtn = document.querySelector('.link-previous-btn');
  const nextBtn = document.querySelector('.link-next-btn');

  const previousSliderBtn = document.getElementById('link-previous-btn-slidenav');
  const nextSliderBtn = document.getElementById('link-next-btn-slidenav');

  previousBtn.addEventListener('click', () => {
    previousSliderBtn.click();
  });

  nextBtn.addEventListener('click', () => {
    nextSliderBtn.click();
  });
};

export default initLinkSlider;
